import {TYPE_COMPONETS} from '../constants'
import extendComponents from '../extendComponents'

let vselect = {
...extendComponents(TYPE_COMPONETS.V_SELECT_COMPLEX),
  relative: null,
  search: false,
  selectLabel: 'label',
  SearchType: null
}

export default vselect
